class ProductMaspCard extends HTMLElement {
  connectedCallback() {
    this._swatches = this.querySelectorAll('[data-masp-card-target="swatch"]');
    this._image = this.querySelector('[data-masp-card-target="image"]');
    this._price = this.querySelector('[data-masp-card-target="price"]');
    this._link = this.querySelector('[data-masp-card-target="link"]');

    this._swatches.forEach(swatch => {
      swatch.addEventListener('click', e => this._onSwatchClick(e));
    });

    if (this._link) {
      this._link.addEventListener('click', e => this._onLinkClick(e));
    }
  }

  _onSwatchClick(e) {
    e.stopPropagation();
    const { variantId, variantImage, variantPrice } = e.currentTarget.dataset;

    if (this._image && variantImage) {
      this._image.src = variantImage;
    }

    if (this._price && variantPrice) {
      const formatted = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(variantPrice / 100);
      this._price.textContent = formatted;
    }

    this._swatches.forEach(s => s.classList.remove('active'));
    e.currentTarget.classList.add('active');

    if (this._link && variantId) {
      this._link.dataset.variantId = variantId;
    }
  }

  _onLinkClick(e) {
    const { productLink, variantId } = e.currentTarget.dataset;
    if (productLink) {
      window.location.href = variantId
        ? `${productLink}?variant=${variantId}`
        : productLink;
    }
  }
}

customElements.define('product-masp-card', ProductMaspCard);

// Faz o carrossel MASP avançar 1 par (2 cards) por vez em vez do padrão (visibleSlides.length)
function initMaspCarouselScrollStep() {
  const slideshow = document.querySelector('.masp-carousel slideshow-component');
  if (!slideshow) return;

  Object.defineProperty(slideshow, 'nextIndex', {
    get() {
      return Math.min(this.current + 1, (this.slides?.length ?? 1) - 1);
    },
    configurable: true,
  });

  Object.defineProperty(slideshow, 'previousIndex', {
    get() {
      return Math.max(this.current - 1, 0);
    },
    configurable: true,
  });
}

customElements.whenDefined('slideshow-component').then(() => {
  requestAnimationFrame(initMaspCarouselScrollStep);
});
